module.exports = __webpack_public_path__ + "img/gi.18639e42.svg";